import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { contaLocalStorage } from 'dashboard/helper/accountScopedStorage';

// Ids de tarefa sao sequencia por conta: sem o id da conta na chave, marcar o
// sino como visto numa conta apagava o badge da outra.
const SEEN_IDS_KEY = 'tasks_bell_seen_ids';
const SEEN_AT_KEY = 'tasks_bell_seen_at';

const loadSeenIds = () => {
  const ids = contaLocalStorage.getJSON(SEEN_IDS_KEY, []);
  return new Set(Array.isArray(ids) ? ids : []);
};

// Estado de MÓDULO, não de componente: o sino e o ponto do cluster recolhido
// leem o mesmo badge. Com um ref por componente, marcar como visto no sino
// deixava o ponto aceso até o próximo reload.
const seenIds = ref(loadSeenIds());

export function useTasksBellBadge() {
  const store = useStore();

  const notificationsTasks = computed(
    () => store.getters['tasks/getNotificationsTasks'] || []
  );

  const newCount = computed(
    () =>
      (notificationsTasks.value || []).filter(
        task => !seenIds.value.has(task.id)
      ).length
  );

  const badge = computed(() => {
    if (!newCount.value) return '';
    return newCount.value > 99 ? '99+' : String(newCount.value);
  });

  const markAllSeen = () => {
    const ids = (notificationsTasks.value || []).map(task => task.id);
    // Sem conta no contexto nada e gravado, e o badge volta no proximo load.
    contaLocalStorage.setJSON(SEEN_IDS_KEY, ids);
    contaLocalStorage.setItem(SEEN_AT_KEY, String(Date.now()));
    seenIds.value = new Set(ids);
  };

  return { notificationsTasks, newCount, badge, markAllSeen };
}
